import { Typography } from '@iheartjane/reefer';
import { Children } from 'react';
import type { ReactNode } from 'react';

import styles from './wizardResults.module.css';

interface WizardResultsProps {
  children: ReactNode;
}

const ABOVE_FOLD_COUNT = 3;

export function WizardResults({ children }: WizardResultsProps) {
  const childArray = Children.toArray(children);
  const aboveFold = childArray.slice(0, ABOVE_FOLD_COUNT);
  const belowFold = childArray.slice(ABOVE_FOLD_COUNT);

  return (
    <>
      <div className={styles['wrapper']}>
        <Typography variant="header-bold" textAlign="center" mb={8}>
          Your top matches
        </Typography>
        <Typography variant="body" textAlign="center" mb={24}>
          Love your picks. Here are your best matches, plus a few customer
          favorites.
        </Typography>

        <div className={styles['cardGrid']}>{aboveFold}</div>
      </div>

      {belowFold.length > 0 && (
        <div className={`${styles['cardGrid']} ${styles['wrapper']}`}>
          {belowFold}
        </div>
      )}
    </>
  );
}
